// extracted by mini-css-extract-plugin
export default {"wrapper":"R3-z","message":"S3-z","image":"T3-z"};